import { mergeDeepRight } from 'ramda';
import { defaultConfig } from './defaultConfig';

export const configPosition = (pos: 'right' | 'left') => {
  window.Beacon?.('config', mergeDeepRight(defaultConfig, { display: { position: pos } }));
};
